import {
  FETCH_VIRTUOUS_API_KEYS_FAILURE,
  FETCH_VIRTUOUS_API_KEYS_REQUEST,
  FETCH_VIRTUOUS_API_KEYS_SUCCESS,
} from '../actions/virtuous';

const initialState = {
  apiKeysDetails: {
    errors: null,
    isFetching: false,
    results: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VIRTUOUS_API_KEYS_REQUEST:
      return {
        ...state,
        apiKeysDetails: {
          ...state.apiKeysDetails,
          errors: null,
          isFetching: true,
        },
      };
    case FETCH_VIRTUOUS_API_KEYS_SUCCESS:
      return {
        ...state,
        apiKeysDetails: {
          errors: null,
          isFetching: false,
          results: Array.isArray(action.payload) ? action.payload : action.payload?.results || [],
        },
      };
    case FETCH_VIRTUOUS_API_KEYS_FAILURE:
      return {
        ...state,
        apiKeysDetails: {
          errors: action.payload,
          isFetching: false,
          results: [],
        },
      };
    default:
      return state;
  }
};
